module.exports = __webpack_public_path__ + "static/media/p2s4.15df3382.jpg";